import { WidgetProps } from '@rjsf/core';
import { TFunction } from 'i18next';
import React from 'react';
import { useTranslation } from 'react-i18next';

const getTextProps = (t: TFunction) => ({
  yes: t("Kyllä"),
  no: t("Ei")
});

const CheckboxWidget = (props: WidgetProps) => {
  const {
    id,
    value,
    formContext,
    placeholder = "-"
  } = props;

  const texts = getTextProps(useTranslation().t)

  return (
    <div id={id}>
      {value === true ? texts.yes : typeof value !== "undefined" ? texts.no : formContext.emptyValue || placeholder}
    </div>
  )
};

export default CheckboxWidget;
